/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import * as t from "react";
import a from "./base/ConfigurationComponent.mjs";
const o = (e) => /* @__PURE__ */ t.createElement(a, { type: "tile", ...e });
o.displayName = "MapTileLayer";
export {
  o as MapTileLayer
};
